import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Typography } from '@material-ui/core';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import {
    getCentrosCentro, addCentroCentro, removeCentroCentro
} from '../../actions/centros_centro_actions';
import {
    openDialog, hideDialog, setSaveState
} from '../../actions';



const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});



class CentroCentros extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            centros: []
        }
    };


    addCentroCentro = (centro) => {
        this.props.setSaveState(true);
        this.props.addCentroCentro(centro);
    };

    checkCentro = (centro) => {
        return true;
    };


    newCentro = () => {

        this.props.openDialog('EditCentroCentro', {
            centroCentro: {},
            centros:this.props.centros,
            okHandler: this.addCentroCentro,
            checkCentro: this.checkCentro,
            centroid: this.props.centroid
        }, uuidv4());

    };

    removeCentro = (centro, index) => {
        this.props.setSaveState(true);
        this.props.removeCentroCentro(centro);
    };

    componentDidMount() {

        this.props.getCentrosCentro(this.props.centroid);

    };

    componentDidUpdate(prevProps) {
        if(prevProps.centrosCentro !== this.props.centrosCentro){

            const newCentros = this.props.centrosCentro.map(c => {

                return {
                    id: c.id,
                    descr: this.props.centros.find(centro => centro.id === c.hijoId).centro,
                    padre: c.padreId,
                    hijo: c.hijoId
                }

            });

            this.setState({...this.state, centros: newCentros});
        }
    }

    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Centros</Typography>
                {this.props.centrosCentro && !this.props.isLoading ?
                    <NeuriteGrid
                    id="c_c"
                        columns={[
                            { key: 'descr', name: 'Centro', editable: false, dragable: false, width: 100 },
                        ]}
                        rows={this.state.centros}
                        buttonEdit={false}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newCentro}
                        onDeleteClick={this.removeCentro}
                        height={200}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
            </div>
        );

    };

};

CentroCentros.propTypes = {
    //state
    centrosCentro: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getCentrosCentro: PropTypes.func.isRequired,
    addCentroCentro: PropTypes.func.isRequired,
    removeCentroCentro: PropTypes.func.isRequired,
    //parameters
    centroid: PropTypes.number.isRequired,
    
};

function mapStateToProps(state) {
    return {
        centrosCentro: state.centrosCentro.centros,
        isLoading: state.cajasCentro.isLoading,
        centros: state.centros.centros,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        getCentrosCentro,
        addCentroCentro,
        removeCentroCentro,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CentroCentros));